export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Premium Bank",
  headline: "Unlimited Transactions with zero fees",
  description:
    "Get access to out exclusive app that allows you yo send unlimited transactions without getting charges any fees",
  buttonLabel: "Get started",
  imgStart: false,
  img: require("../../images/svg-1.svg"),
  alt: "One",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Unlimited Access",
  headline: "Log to your account at any time",
  description:
    "We have you covered no matter where you are located. All you need is a device with internet connection.",
  buttonLabel: "Learn more",
  imgStart: false,
  img: require("../../images/svg-2.svg"),
  alt: "Two",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjThree = {
  id: "signup",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Premium Bank",
  headline: "Creating an account would take you less than 5 minutes!",
  description:
    "Get everything set up and ready instantly. All you need to do is add your information and you're ready to go.",
  buttonLabel: "Begin adventure",
  imgStart: false,
  img: require("../../images/svg-3.svg"),
  alt: "Three",
  dark: false,
  primary: false,
  darkText: true,
};
